// Imports

import Player from '@vimeo/player';
import * as State from './State.js';

// One Vimeo player plays every video. (Preloading the outcome videos in
// hidden extra players was tried in September 2026, but a hidden player that
// was swapped in sometimes stayed stuck at 0:00 for good, freezing the game.)

let embed;
let player;

// Increased on every Load, so a slower earlier Load can't start playing after
// a newer one.
let loadToken = 0;

// Timestamp of the decision moment of the current video, until it is reached.
// Vimeo cuepoints can fail to register ("InvalidCuePoint"), so timeupdate is
// used as a fallback to still pause at the decision moment.
let pendingCue = null;

let initialized = false;

export function Initialize(){

	// prevent initialization to happen multiple times
	if(initialized) return;
	initialized = true;

	embed = document.getElementById('embed');
	player = new Player(embed);

	// Listeners
	document.addEventListener('pause', () => {Pause();});
	document.addEventListener('resume', Play);

	player.on('ended', OnEnded);
	player.on('cuepoint', OnCuePoint);
	player.on('loaded', (e) => OnLoaded(e));
	player.on('play', OnPlaying);
	player.on('timeupdate', OnTimeUpdate);

	window.addEventListener('keydown', onDocumentKeyDown, false);
}

function onDocumentKeyDown(event){
	switch(event.which){
	case 39:
		SkipAhead();
		break;

	case 40:
		if(!event.altKey) return;
		player.getDuration().then(function(duration) {
			player.setCurrentTime(duration - 1);
		});
		break;

	}
}

// Right arrow: skip the main story to just before the choices, or an outcome
// video to its last 10 seconds. Never seeks past the decision moment.
function SkipAhead(){
	Promise.all([player.getCurrentTime(), player.getDuration()]).then(function([time, duration]) {
		const target = pendingCue != null ? pendingCue - 3 : duration - 10;
		if(target > time){
			player.setCurrentTime(target);
		}
	});
}

// Events


const endedEvent = new Event('video_ended');
//const cuepointEvent = new CustomEvent('video_cuepoint');
const loadedEvent = new Event('video_loaded');
const playingEvent = new Event('video_playing');
const pausedEvent = new Event('video_paused');


function OnEnded(){
	document.dispatchEvent(endedEvent);
}

function OnCuePoint(event){
	player.removeCuePoint(event.id);
	if(event.data?.event === 'decisions') pendingCue = null;
	document.dispatchEvent(new CustomEvent('video_cuepoint', {detail : event}));
}

function OnTimeUpdate(e){
	if(pendingCue == null || e.seconds < pendingCue) return;
	pendingCue = null;
	document.dispatchEvent(new CustomEvent('video_cuepoint', {detail : {data: {event: 'decisions'}}}));
}

function OnLoaded(e){
	document.dispatchEvent(loadedEvent);
}

function OnPlaying(){
	document.dispatchEvent(playingEvent);
}



// Public Functions

export function Load(id, cuePointTimestamp){
	const token = ++loadToken;
	pendingCue = null;

	player.loadVideo(id).then(function() {
		if(token !== loadToken) return;
		AddCuePoint(cuePointTimestamp);
		Play();
	}).catch(function(error){
		console.error('Aftrap: could not load video ' + id, error);
	});
}

function AddCuePoint(cuePointTimestamp){
	if(cuePointTimestamp != null){
		pendingCue = cuePointTimestamp;
		player.addCuePoint(cuePointTimestamp, {'event':'decisions'})
			.catch(function(error){
				console.warn('Aftrap: could not add the decision cuepoint at ' + cuePointTimestamp + 's, using timeupdate instead', error);
			});
	}
}

export function Play(){
	player.play();

}

export function Pause(){
	player.pause();
	document.dispatchEvent(pausedEvent);
}

document.addEventListener('state_togglePause', TogglePlayback);

function TogglePlayback(){
	player.getPaused().then(function(paused){
		if(paused){
			Play();
		}
		else{
			Pause();
			setTimeout(function(){State.ChangeState('togglePause');}, 100);
		}
	});

}


export function SetPlaybackPosition(timestamp){
	player.setCurrentTime(timestamp);
}

export function SetSound(state){
	player.setVolume(state ? 1 : 0);
}
